module.exports = __webpack_public_path__ + "img/sales.586836b5.svg";